// import router from "../../router";
//import eventBus from "../../../main";
//import jwtDecode from "jwt-decode";

import apiServices from "../../../../services/apiServices";

export default {
  state: {
    profile: Object,
    bokre: "3AE58934E5D363B5938F379019C32F62"
  },
  mutations: {
    SET_USER_NAME(state, value) {
      state.profile = value;
    }
  },
  actions: {
    // Get Client Profile and Address
    getClient(context, ref) {
      // eventBus.$emit("openSpin", true); // emit the event to the bus
      return apiServices
        .getClients(ref)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_USER_NAME", obj.message[0]);

            }
          }
        })
        .catch(function() {})
        .finally(function() {
          // eventBus.$emit("openSpin", false);
        });
    }
  },

  getters: {
    getAvatarClient(state) {
      return state.profile.Avatar;
    },
    getUserName(state) {
      let first = state.profile.PrimeiroNome ? state.profile.PrimeiroNome : "";
      let last = state.profile.UltimoNome ? state.profile.UltimoNome : "";
      return first + " " + last;
    },
    getFirstName(state) {
      return state.profile.PrimeiroNome;
    },
    getFullName(state) {
      let first = state.profile.PrimeiroNome ? state.profile.PrimeiroNome : "";
      let second = state.profile.NomeDoMeio ? state.profile.NomeDoMeio : "";
      let last = state.profile.UltimoNome ? state.profile.UltimoNome : "";
      return first + " " + second + " " + last;
    },
    getAddress(state) {
      return state.profile.Endereco ? state.profile.Endereco : "";
    },
    getCellphone(state) {
      return state.profile.Celular ? state.profile.Celular : "";
    },
    getTelephone(state) {
      return state.profile.Telefone ? state.profile.Telefone : "";
    },
    getBokre(state) {
      return state.bokre;
    }
  }
};
